module.exports = __webpack_public_path__ + "img/ml3041.9bac844a.png";